module.exports = __webpack_public_path__ + "static/media/contract.10f75df7.svg";